import { toggleIt } from './utils/showHide';
import { copyToClipboard } from './utils/copyToClipboard';

/**
 * Shuffels card in a ghwp-image-cards-container block
 *
 */

export const shuffleCards = (
    containerSelector = '.ghwp-image-cards-container',
) => {

    const containers = document.querySelectorAll(containerSelector);
    containers.forEach(container => {
        if (container.dataset.shuffle !== 'true') {
            return;
        }
        for (var i = container.children.length; i >= 0; i--) {
            container.appendChild(container.children[Math.random() * i | 0]);
        }
    });
};
